export default __webpack_public_path__ + "static/media/white_notext.9ca3a4ed.png";